<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-driver" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let driver of (drivers$ | async)?.content"
          (onSelectionChange)="handleDriverChange($event, driver)"
          [value]="driver.name + ' - ' + driver.username"
          class="autocomplete"
        >
          {{ driver.name }} - {{ driver.username }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ requiredText || "required-driver" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
